import { render, staticRenderFns } from "./edit-scope-of-application.vue?vue&type=template&id=48d2432e&scoped=true&"
import script from "./edit-scope-of-application.vue?vue&type=script&lang=js&"
export * from "./edit-scope-of-application.vue?vue&type=script&lang=js&"
import style0 from "./edit-scope-of-application.vue?vue&type=style&index=0&id=48d2432e&lang=scss&scoped=true&"
import style1 from "./edit-scope-of-application.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2432e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d2432e')) {
      api.createRecord('48d2432e', component.options)
    } else {
      api.reload('48d2432e', component.options)
    }
    module.hot.accept("./edit-scope-of-application.vue?vue&type=template&id=48d2432e&scoped=true&", function () {
      api.rerender('48d2432e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/manager/edit-scope-of-application.vue"
export default component.exports